import React, { useMemo } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import couponBasedImg from "assets/images/cards/products/couponBased.png"
import lowStockImg from "assets/images/cards/products/lowStock.png"
import oneTimeBasedImg from "assets/images/cards/products/oneTimeBased.png"
import outOfStockImg from "assets/images/cards/products/outOfStock.png"
import totalProductsImg from "assets/images/cards/products/totalProducts.png"

export const ProductCards = () => {
  const { t } = useTranslation()
  const reports: { title: string; total: number | string; img: string }[] = useMemo(() => {
    return [
      {
        title: t("products_totalProducts"),
        total: 15,
        img: totalProductsImg,
      },
      {
        title: t("products_couponBased"),
        total: 8,
        img: couponBasedImg,
      },
      {
        title: t("products_oneTimeBased"),
        total: 12,
        img: oneTimeBasedImg,
      },
      {
        title: t("products_lowStock"),
        total: 5,
        img: lowStockImg,
      },
      {
        title: t("products_outOfStock"),
        total: 3,
        img: outOfStockImg,
      },
    ]
  }, [t])

  return (
    <Row className="mt-2">
      <style>
        {`
          @media (min-width: 1200px) {
            .col-lg-5ths {
              flex: 0 0 20%;
              max-width: 20%;
            }
          }
        `}
      </style>
      {reports.map((report, key) => (
        <Col md="4" lg="2.4" key={"_col_" + key} className="col-lg-5ths">
          <Card className="mini-stats-wid shadow-md rounded-3">
            <CardBody>
              <div className="d-flex">
                <div className="flex-grow-1">
                  <p className="text-muted fw-medium text-capitalize">
                    {report.title}
                  </p>
                  <h4 className="mb-0">{report.total}</h4>
                </div>
                <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                  <span className="avatar-title rounded-circle bg-primary">
                    <img src={report.img} alt={report.title} className="img-fluid" />
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}
